import { useAdGroupCreatives } from '@apis/creatives';
import { useStaticDisplayAdGroupCreatives } from '@apis/displays';
import { entityVariant } from '@components/Wizard/components/Subway/constants';
import { useIsNewSubway } from '@components/Wizard/hooks/useIsNewSubway';
import { Status } from '@constants/status';
import { useMemo } from 'react';
import { useWizardSubwaySection } from '../../Wizard';
import { StyledSubwayEntity } from '../styles';
import GroupSectionSubwayOld from './GroupSectionSubwayOld';
import { labels, menuLabels } from './constants';
import { GroupSectionSubwayProps } from './types';

const GroupSectionSubway = (props: GroupSectionSubwayProps) => {
  const isNewSubway = useIsNewSubway();
  const { active, setActiveSection } = useWizardSubwaySection({
    key: props.sectionKey,
    defaultPaneKey: labels.nameDates.value,
  });

  if (!isNewSubway) {
    return <GroupSectionSubwayOld {...props} />;
  }

  const { items: lib } = useAdGroupCreatives(props.group, {
    disabled: props.isDisplay,
  });

  const { items: displayLib } = useStaticDisplayAdGroupCreatives(
    props.group,
    {
      disabled: !props.isDisplay,
    }
  );

  const creatives = useMemo(
    () => (props.isDisplay ? displayLib : lib) ?? [],
    [props.isDisplay, displayLib, lib]
  );

  return (
    <StyledSubwayEntity
      {...props.group}
      disabled={props.disabled}
      sectionKey={props.sectionKey}
      menuOptions={[
        {
          label: menuLabels.duplicate,
          onClick: props.onDuplicate,
          disabled:
            props.isLoading ||
            props.group.temporary ||
            !!props.campaign?.experiment_plan,
        },
        {
          label: menuLabels.delete,
          onClick: props.onDelete,
          disabled:
            props.isLoading ||
            props.group.status === Status.ACTIVE ||
            !!props.campaign?.experiment_plan ||
            (props.groups.length === 1 && !props.groups[0].temporary),
          type: 'warning',
        },
      ]}
      creativeNames={creatives.map(creative => creative.name)}
      onClick={() => setActiveSection(props.sectionKey)}
      variant={entityVariant.group}
      selected={active}
      title={props.group.name}
      status={props.group.temporary ? 'UNSAVED' : props.group.status}
      id={props.group.temporary ? undefined : props.group.id}
    />
  );
};

export default GroupSectionSubway;
